import React from 'react';
import SectionCard from './SectionCard';
import { ChevronDown } from 'lucide-react';
import { RadioGroup, RadioGroupItem } from '../../../components/ui/radio-group';

const StrataOptionsSection = ({ submission, jsonContent, isDark }) => {
    return (
        <>
            {/* Plan Number - For Strata (required) and Non-Strata (optional, only if filled) */}
            {(submission.recipient_source !== 'non-strata' || submission.planNumber) && (
                <SectionCard isDark={isDark}>
                    <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>Plan Number {submission.recipient_source !== 'non-strata' && <span className='text-red-500'>*</span>}</p>
                    <div className={`flex items-center w-full border-none rounded-[8px] overflow-hidden transition-colors duration-200 ${
                        isDark ? 'bg-[#161515] ' : 'bg-[#f5f5f5] border-solid border-[1px] border-[f8f9fa] '
                    }`}>
                        <div className="flex items-center relative min-w-[80px]">
                        <select
                                className={`px-[16px] py-[12px] pr-[32px] text-[16px] bg-transparent border-0 outline-none appearance-none cursor-pointer w-full transition-colors duration-200 ${
                                    isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
                                }`}
                                disabled
                        >
                            <option value={submission.planType}>{submission.planType}</option>
                        </select>
                            <ChevronDown className={`absolute right-[12px] w-[16px] h-[16px] pointer-events-none transition-colors duration-200 ${
                                isDark ? 'text-[#b3b3b3]' : 'text-[#686868]'
                            }`} />
                        </div>
                        <div className={`w-px h-[24px] transition-colors duration-200 ${
                            isDark ? 'bg-[#292929]' : 'bg-[#d9d9d9]'
                        }`}></div>
                        <input
                            className={`flex-1 px-[16px] py-[12px] border-0 outline-none text-[16px] bg-transparent transition-colors duration-200 ${
                                isDark
                                    ? 'text-white placeholder:text-[#b3b3b3]'
                                    : 'text-[#072837] placeholder:text-[#898989]'
                            }`}
                            type="text"
                            value={submission.planNumber || ''}
                            readOnly
                            placeholder="Enter Plan no."
                        />
                    </div>
                </SectionCard>
            )}

            {/* Sending - Only for Strata submissions */}
            {submission.recipient_source !== 'non-strata' && (
            <SectionCard isDark={isDark}>
                <p className={`text-[16px] font-semibold m-0 transition-colors duration-200 ${
                    isDark ? 'text-white' : 'text-[#072837]'
                }`}>Sending <span className='text-red-500'>*</span></p>
                <RadioGroup value={submission.sending}>
                    <div className='flex flex-col gap-[14px]'>
                        <div className='flex gap-[8px] items-center'>
                            <RadioGroupItem value={submission.sending} id={`sending-${submission.sending}`} />
                            <label htmlFor={`sending-${submission.sending}`} className={`text-[16px] m-0 cursor-default transition-colors duration-200 ${
                                isDark ? 'text-white' : 'text-[#072837]'
                            }`}>{submission.sending}</label>
                        </div>
                    </div>
                </RadioGroup>
                {submission.email_subject && submission.email_subject !== '' && (
                    <div className="flex flex-col gap-[8px] w-full">
                        <p className={`text-[14px] font-medium m-0 transition-colors duration-200 ${
                            isDark ? 'text-[#b0b0b0]' : 'text-[#686868]'
                        }`}>Email Subject</p>
                        <input
                            className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                isDark
                                    ? 'bg-[#1a1a1a] text-white'
                                    : 'bg-[#f5f5f5] text-[#072837]'
                            }`}
                            type="text"
                            value={submission.email_subject}
                            readOnly
                        />
                    </div>
                )}
            </SectionCard>
            )}

            {/* Custom Document Name */}
            {submission.custom_document_name && submission.custom_document_name !== '' && (
                <SectionCard isDark={isDark}>
                    <p className={`m-0 text-[16px] font-semibold transition-colors duration-200 ${
                        isDark ? 'text-white' : 'text-[#072837]'
                    }`}>Custom Document Name</p>
                    <div>
                        <input 
                            className={`w-full px-[16px] py-[12px] rounded-[8px] border-none text-[16px] transition-colors duration-200 focus:outline-none focus:ring-0 focus:border-transparent ${
                                isDark 
                                    ? 'bg-[#161515]  text-white' 
                                    : 'bg-[#f5f5f5] text-[#072837]'
                            }`} 
                            type="text" 
                            value={submission.custom_document_name || jsonContent.custom_document_name || ''} 
                            readOnly 
                        />
                    </div>
                </SectionCard>
            )}
        </>
    );
};

export default StrataOptionsSection;
